import React from "react";
import { NavLink } from "react-router-dom";

const ActiveLink = ({ to, children }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive
          ? " border-white text-white shadow-2xl border-b-2  capitalize font-bold"
          : "text-white"
      }
    >
      {children}
    </NavLink>
  );
};

export default ActiveLink;
